import { Injectable } from '@angular/core';

import { TreeItem } from '@frontend/sports/item/feature';
import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';
import { TopItemsType } from '@frontend/sports/types/components/widget/types';

@Injectable()
export class TopItemsTrackingService {
    constructor(private trackingService: TrackingService) {}
    private trackingSourceMapping = {
        [TopItemsType.TopCompetitions]: 'Top Competitions',
        [TopItemsType.TopCountries]: 'Top Regions',
        [TopItemsType.TopSports]: 'Top Sports',
    };

    private trackingDetailsMapping = {
        [TopItemsType.TopCompetitions]: 'competition',
        [TopItemsType.TopCountries]: 'region',
        [TopItemsType.TopSports]: 'sport',
    };

    private trackingShowAllMapping = {
        [TopItemsType.TopCompetitions]: 'see all competitions',
        [TopItemsType.TopCountries]: 'see all regions',
        [TopItemsType.TopSports]: 'see all sports',
    };

    private trackingIdMapping = (id: number | string): { [key: string]: Partial<TrackData> } => ({
        [TopItemsType.TopCompetitions]: { [trackingConstants.SPORT_LEAGUE_ID]: id.toString() },
        [TopItemsType.TopCountries]: { [trackingConstants.REGION_ID]: id.toString() },
        [TopItemsType.TopSports]: { [trackingConstants.SPORT_ID]: id.toString() },
    });

    trackItemClicked(item: TreeItem, itemType: TopItemsType, index: number): void {
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Top Items Modules',
            [trackingConstants.COMPONENT_LABEL_EVENT]: this.trackingSourceMapping[itemType],
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: this.trackingDetailsMapping[itemType],
            [trackingConstants.COMPONENT_CONTENT_POSITION]: index.toString(),
            [trackingConstants.COMPONENT_URL_CLICKED]: item.href ?? NOT_APPLICABLE,
            ...this.trackingIdMapping(item.id)[itemType],
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }

    trackMoreClicked(itemType: TopItemsType): void {
        const trackingData = {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Top Items Modules',
            [trackingConstants.COMPONENT_LABEL_EVENT]: this.trackingSourceMapping[itemType],
            [trackingConstants.COMPONENT_ACTION_EVENT]: 'Click',
            [trackingConstants.COMPONENT_POSITION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_LOCATION_EVENT]: NOT_APPLICABLE,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: this.trackingShowAllMapping[itemType],
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };

        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackingData);
    }
}
